export const APIKey = "951446c9e47a99cb6ccfb776c60023c7";

export const APIUrl = "https://api.themoviedb.org/3";

export const APIImageUrl = "https://image.tmdb.org/t/p";
